// Generated by Melange

import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as Lui_elements from "lui/lui_elements.js";
import * as Mapre_chat__Chat_attachment from "../../shared/chat/chat_attachment.js";
import * as Mapre_web__Web_attachment_input from "./web_attachment_input.js";
import * as Mapre_web__Web_attachments_controller from "./web_attachments_controller.js";
import * as Mapre_web__Web_attachments_model from "./web_attachments_model.js";
import * as Signal from "ocaml-signal/signal.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__String from "melange/string.js";

function state_name(param) {
  if (/* tag */ typeof param !== "object" && typeof param !== "function") {
    return "uploading";
  } else if (param.TAG === /* Ready */ 0) {
    return "ready";
  } else {
    return "failed";
  }
}

function action(send, target, value) {
  const partial_arg = {
    TAG: /* Attachments */ 44,
    _0: target,
    _1: value
  };
  return function (param) {
    return Lui_elements.press(send, partial_arg, param);
  };
}

function strip(target, source, send) {
  const attachments = Signal.map((function (param) {
    return Mapre_web__Web_attachments_controller.draft(target, param);
  }), source);
  const partial_arg = Signal.map((function (state) {
    return state.items;
  }), attachments);
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.keyed(partial_arg, (function (item) {
      return item.file.key;
    }), Stdlib__String.compare, (function (param) {
      const first = Signal.sample(param);
      const url = first.file.preview;
      let tmp;
      if (url !== undefined) {
        const partial_arg = first.file.name;
        const partial_arg$1 = first.file.name;
        const partial_arg$2 = url;
        const partial_arg$3 = 80;
        const partial_arg$4 = 120;
        tmp = (function (param, param$1) {
          return Lui_elements.image(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, /* [] */ 0, param, param$1);
        });
      } else {
        tmp = (function (param, param$1) {
          return Lui_elements.column(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        });
      }
      const partial_arg$5 = first.file.name;
      const partial_arg$6 = {
        hd: [
          "data-attachment-name",
          ""
        ],
        tl: /* [] */ 0
      };
      const partial_arg$7 = "attachment-name";
      const partial_arg$8 = Signal.map((function (item) {
        const match = item.status;
        if (/* tag */ typeof match !== "object" && typeof match !== "function" || match.TAG === /* Ready */ 0) {
          return false;
        } else {
          return true;
        }
      }), param);
      const partial_arg_0 = function (param, param$1) {
        return Lui_elements.if_(partial_arg$8, (function (param, param$1) {
          return Lui_elements.scoped((function (__lui_context___002_) {
            const partial_arg = action(send, target, {
              TAG: /* Retry */ 4,
              _0: first.file.key
            });
            const partial_arg$1 = Caml_option.some(Signal.own_signal(__lui_context___002_.ui_scope, Signal.map((function (model) {
              return !Mapre_web__Web_attachments_controller.allowed(target, model);
            }), source)));
            const partial_arg$2 = "Retry upload " + first.file.name;
            const partial_arg$3 = "sm";
            const partial_arg$4 = "outline";
            const partial_arg$5 = "Retry upload";
            return function (param, param$1) {
              return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, undefined, partial_arg$4, partial_arg$3, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
            };
          }), param, param$1);
        }), param, param$1);
      };
      const partial_arg_1 = {
        hd: (function (param, param$1) {
          return Lui_elements.scoped((function (__lui_context___003_) {
            const partial_arg = action(send, target, {
              TAG: /* Remove */ 3,
              _0: first.file.key
            });
            const partial_arg$1 = Caml_option.some(Signal.own_signal(__lui_context___003_.ui_scope, Signal.map((function (model) {
              return !Mapre_web__Web_attachments_controller.allowed(target, model);
            }), source)));
            const partial_arg$2 = "Remove " + first.file.name;
            const partial_arg$3 = {
              NAME: "app",
              VAL: "x"
            };
            const partial_arg$4 = "icon";
            const partial_arg$5 = "ghost";
            return function (param, param$1) {
              return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, partial_arg$4, partial_arg$3, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
            };
          }), param, param$1);
        }),
        tl: /* [] */ 0
      };
      const partial_arg$9 = {
        hd: partial_arg_0,
        tl: partial_arg_1
      };
      const partial_arg$10 = 4;
      const partial_arg_1$1 = {
        hd: (function (param, param$1) {
          return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$7, partial_arg$6, undefined, undefined, undefined, undefined, undefined, partial_arg$5, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        }),
        tl: {
          hd: (function (param$1, param$2) {
            return Lui_elements.scoped((function (__lui_context___001_) {
              const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___001_.ui_scope, Signal.map((function (item) {
                let message = item.status;
                if (/* tag */ typeof message !== "object" && typeof message !== "function") {
                  return "Uploading...";
                } else if (message.TAG === /* Ready */ 0) {
                  return "Ready";
                } else {
                  return message._0;
                }
              }), param)));
              const partial_arg$1 = "muted";
              return function (param, param$1) {
                return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
              };
            }), param$1, param$2);
          }),
          tl: {
            hd: (function (param, param$1) {
              return Lui_elements.row(undefined, partial_arg$10, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$9, param, param$1);
            }),
            tl: /* [] */ 0
          }
        }
      };
      const partial_arg$11 = {
        hd: tmp,
        tl: partial_arg_1$1
      };
      const partial_arg$12 = Caml_option.some(Signal.map((function (item) {
        return {
          hd: [
            "data-draft-attachment",
            item.file.key
          ],
          tl: {
            hd: [
              "data-upload-state",
              state_name(item.status)
            ],
            tl: /* [] */ 0
          }
        };
      }), param));
      const partial_arg$13 = "attachment-card";
      const partial_arg$14 = 180;
      const partial_arg$15 = 0;
      const partial_arg$16 = 12;
      const partial_arg$17 = 8;
      const partial_arg$18 = 4;
      return function (param, param$1) {
        return Lui_elements.column(undefined, partial_arg$18, undefined, undefined, undefined, undefined, undefined, partial_arg$17, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$16, undefined, undefined, partial_arg$15, partial_arg$14, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$13, undefined, partial_arg$12, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$11, param, param$1);
      };
    }), param, param$1);
  };
  const partial_arg$1 = {
    hd: partial_arg_0,
    tl: /* [] */ 0
  };
  const partial_arg$2 = "attachment-strip";
  const partial_arg$3 = 0;
  const partial_arg$4 = 8;
  const partial_arg$5 = Signal.map((function (state) {
    return state.message !== "";
  }), attachments);
  return {
    hd: (function (param, param$1) {
      return Lui_elements.row(undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.if_(partial_arg$5, (function (param, param$1) {
          return Lui_elements.scoped((function (__lui_context___004_) {
            const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___004_.ui_scope, Signal.map((function (state) {
              return state.message;
            }), attachments)));
            const partial_arg$1 = "notice";
            return function (param, param$1) {
              return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
            };
          }), param, param$1);
        }), param, param$1);
      }),
      tl: /* [] */ 0
    }
  };
}

function input(target, source, send, children) {
  const attachments = Signal.map((function (param) {
    return Mapre_web__Web_attachments_controller.draft(target, param);
  }), source);
  const partial_arg = 0;
  const partial_arg$1 = Stdlib.$at(strip(target, source, send), {
    hd: (function (param, param$1) {
      return Lui_elements.column(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, children, param, param$1);
    }),
    tl: /* [] */ 0
  });
  const partial_arg$2 = 0;
  const partial_arg$3 = 6;
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, param, param$1);
  };
  const partial_arg$4 = {
    hd: partial_arg_0,
    tl: /* [] */ 0
  };
  const partial_arg$5 = Signal.map(Mapre_web__Web_attachments_model.keys, attachments);
  const partial_arg$6 = Signal.map((function (model) {
    return !Mapre_web__Web_attachments_controller.allowed(target, model);
  }), source);
  return function (param, param$1) {
    return Mapre_web__Web_attachment_input.view(undefined, partial_arg$6, partial_arg$5, (function (files) {
      Curry._1(send, {
        TAG: /* Attachments */ 44,
        _0: target,
        _1: {
          TAG: /* Selected */ 0,
          _0: files
        }
      });
    }), (function (message) {
      Curry._1(send, {
        TAG: /* Attachments */ 44,
        _0: target,
        _1: {
          TAG: /* Error */ 5,
          _0: message
        }
      });
    }), partial_arg$4, param, param$1);
  };
}

function transcript(workspace, source) {
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.keyed(source, (function (reference) {
      return reference.id;
    }), Stdlib__String.compare, (function (reference) {
      const first = Signal.sample(reference);
      const path = "/api/workspaces/" + (workspace + ("/attachments/" + first.id));
      let tmp;
      if (Mapre_chat__Chat_attachment.image(first.media_type)) {
        const partial_arg = first.name;
        const partial_arg$1 = first.name;
        const partial_arg$2 = path;
        const partial_arg$3 = 80;
        const partial_arg$4 = 120;
        tmp = (function (param, param$1) {
          return Lui_elements.image(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, /* [] */ 0, param, param$1);
        });
      } else {
        tmp = (function (param, param$1) {
          return Lui_elements.column(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        });
      }
      const partial_arg$5 = "Download " + first.name;
      const partial_arg$6 = first.name;
      const partial_arg$7 = path;
      const partial_arg$8 = "attachment-name";
      const partial_arg_1 = {
        hd: (function (param, param$1) {
          return Lui_elements.link(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$8, undefined, undefined, undefined, undefined, undefined, partial_arg$7, undefined, undefined, partial_arg$6, undefined, undefined, undefined, undefined, partial_arg$5, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        }),
        tl: /* [] */ 0
      };
      const partial_arg$9 = {
        hd: tmp,
        tl: partial_arg_1
      };
      const partial_arg$10 = "attachment-card";
      const partial_arg$11 = 180;
      const partial_arg$12 = 0;
      const partial_arg$13 = 4;
      return function (param, param$1) {
        return Lui_elements.column(undefined, partial_arg$13, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$12, partial_arg$11, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$10, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$9, param, param$1);
      };
    }), param, param$1);
  };
  const partial_arg = {
    hd: partial_arg_0,
    tl: /* [] */ 0
  };
  const partial_arg$1 = "attachment-strip";
  const partial_arg$2 = 0;
  const partial_arg$3 = 8;
  return function (param, param$1) {
    return Lui_elements.row(undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, param, param$1);
  };
}

export {
  input,
  strip,
  transcript,
}
/* Lui_elements Not a pure module */
